import { ROLES } from 'components/users/utils/userRoles';

export const quarantinePermission = {
  allowedRoles: [ROLES.ADMIN, ROLES.OUS_CALA, ROLES.OPERATIONS, ROLES.REGULATORY],
};
